import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-schuldigerkenningen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-schuldigerkenningen.component.html',
  styleUrl: './tekst-schuldigerkenningen.component.scss',
})
export class TekstSchuldigerkenningenComponent {}
